<header class="site-header">
  <div class="header-inner">
    <!-- Logo -->
    <a
      [routerLink]="homeRoute()"
      class="logo"
      [attr.aria-label]="brand.homeAriaLabel"
      [title]="brand.homeAriaLabel"
    >
      <img [src]="brand.logoPath" alt="" class="logo-img" />
    </a>

    <!-- Desktop Navigation -->
    <nav class="desktop-nav" aria-label="Primary navigation">
      @for (item of navItems(); track item.path) {
        <a [routerLink]="item.path" routerLinkActive="active" class="nav-item" [title]="item.label">
          <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
          <span>{{ item.label }}</span>
        </a>
      }
    </nav>

    <!-- Right side -->
    <div class="header-right">
      <!-- Site switcher (multi-site site managers only) -->
      @if (auth.showSiteSwitcher()) {
        <div class="site-switcher">
          <mat-icon aria-hidden="true" class="site-switcher-icon">apartment</mat-icon>
          <select
            class="site-switcher-select"
            aria-label="Select setting"
            title="Select setting"
            (change)="onSiteChange($event)"
          >
            @for (site of auth.siteManagerSites(); track site.OrganizationID) {
              <option
                [value]="site.OrganizationID"
                [selected]="site.OrganizationID === auth.activeOrganization()?.OrganizationID"
              >
                {{ site.OrganizationName || 'Setting ' + site.OrganizationID }}
              </option>
            }
          </select>
        </div>
      }

      <!-- Help -->
      <a
        routerLink="/help"
        [queryParams]="helpQueryParams()"
        class="icon-btn"
        aria-label="Help for this page"
        title="Help for this page"
      >
        <mat-icon aria-hidden="true">help_outline</mat-icon>
      </a>

      <!-- User Menu -->
      <div class="user-menu-wrapper">
        <button
          class="user-btn"
          type="button"
          aria-haspopup="menu"
          [attr.aria-expanded]="userMenuOpen()"
          aria-controls="user-menu"
          [attr.aria-label]="'Open user menu for ' + userName()"
          [title]="'Open user menu for ' + userName()"
          (click)="toggleUserMenu()"
        >
          <div class="avatar" aria-hidden="true">{{ userInitials() }}</div>
          <span class="user-name">{{ userName() }}</span>
          <mat-icon aria-hidden="true">expand_more</mat-icon>
        </button>

        @if (userMenuOpen()) {
          <div id="user-menu" class="user-dropdown" role="menu">
            <div class="dropdown-header">
              <p class="dropdown-email">{{ auth.currentUser()?.Email }}</p>
              <span class="role-badge" [class]="auth.currentUserRole()">
                {{ roleLabel() }}
              </span>
            </div>

            <a
              routerLink="/profile"
              class="dropdown-item"
              role="menuitem"
              title="Profile"
              (click)="closeUserMenu()"
            >
              <mat-icon aria-hidden="true">manage_accounts</mat-icon>
              Profile
            </a>

            @if (auth.hasRole(['SITEMANAGER'])) {
              <a
                routerLink="/settings"
                class="dropdown-item"
                role="menuitem"
                title="Setting details"
                (click)="closeUserMenu()"
              >
                <mat-icon aria-hidden="true">settings</mat-icon>
                Setting details
              </a>
            }

            @if (auth.hasRole(['SUPERUSER'])) {
              <a
                routerLink="/admin"
                class="dropdown-item"
                role="menuitem"
                title="Admin"
                (click)="closeUserMenu()"
              >
                <mat-icon aria-hidden="true">admin_panel_settings</mat-icon>
                Admin
              </a>
            }

            @if (hasAssignedDocsAccess()) {
              <a
                routerLink="/docs/getting-started"
                class="dropdown-item"
                role="menuitem"
                title="Full docs"
                (click)="closeUserMenu()"
              >
                <mat-icon aria-hidden="true">menu_book</mat-icon>
                Full docs
              </a>
            }

            <hr class="dropdown-divider" />

            @if (brand.isDemo) {
              <button
                class="dropdown-item"
                role="menuitem"
                title="Reset demo"
                (click)="resetDemo()"
              >
                <mat-icon aria-hidden="true">restart_alt</mat-icon>
                Reset demo
              </button>
            }

            <button
              class="dropdown-item signout"
              role="menuitem"
              title="Sign out"
              (click)="auth.logout()"
            >
              <mat-icon aria-hidden="true">logout</mat-icon>
              Sign out
            </button>
          </div>
        }
      </div>

      <!-- Mobile menu toggle -->
      <button
        class="icon-btn mobile-toggle"
        type="button"
        [attr.aria-expanded]="mobileMenuOpen()"
        aria-controls="mobile-navigation"
        [attr.aria-label]="mobileMenuOpen() ? 'Close navigation menu' : 'Open navigation menu'"
        [title]="mobileMenuOpen() ? 'Close navigation menu' : 'Open navigation menu'"
        (click)="toggleMobileMenu()"
      >
        <mat-icon aria-hidden="true">{{ mobileMenuOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
  </div>

  @if (brand.isDemo) {
    <p class="demo-notice" role="status">
      <span>{{ brand.dataNotice }}</span>
    </p>
  }

  <!-- Mobile Navigation -->
  @if (mobileMenuOpen()) {
    <nav id="mobile-navigation" class="mobile-nav" aria-label="Mobile navigation">
      @for (item of navItems(); track item.path) {
        <a
          [routerLink]="item.path"
          routerLinkActive="active"
          class="nav-item"
          [title]="item.label"
          (click)="closeMobileMenu()"
        >
          <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
          <span>{{ item.label }}</span>
        </a>
      }
    </nav>
  }
</header>
